import styled from "styled-components";

const BessInputsWrapper = styled.section`
  width: 100%;
  padding: 10px;

  .info-col {
    width: 100%;
    display: grid;
    place-items: center;

    p {
      font-size: 11px;
      margin: 5px 0px;
    }
  }

  .input-2-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "label battInput";
    place-items: center start;
    margin: 8px 0px;

    label {
      grid-area: label;
      margin: 0px;
    }

    input {
      grid-area: battInput;
      margin-left: auto;
      max-width: 120px;
    }

    p {
      grid-area: battInput;
      margin: 0px;
      margin-left: auto;
    }
  }

  .force-cycle {
    display: grid;
    grid-template-columns: auto 1fr;
    /* padding: 0px 5px 0px 0px; */
    align-content: center;
    margin-bottom: 5px;
  }

  .time-selector {
    width: 100%;
    display: grid;
    -webkit-align-items: baseline;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    grid-template-columns: 106px 1fr;
    gap: 15px;
    white-space: nowrap;
  }
`;

export { BessInputsWrapper };
